import type { ReactElement } from 'react';

import { About } from '~/components/sections/About';
import { Certification } from '~/components/sections/Certification';
import { Contact } from '~/components/sections/Contact';
import { Hero } from '~/components/sections/Hero';
import { Portfolio } from '~/components/sections/Portfolio';
import { ProcessTimeline } from '~/components/sections/ProcessTimeline';
import { RailwaySpecialisation } from '~/components/sections/RailwaySpecialisation';
import { Services } from '~/components/sections/Services';
import { WhyArpa } from '~/components/sections/WhyArpa';

/**
 * HomePage — composes all sections in order.
 *
 * The Portfolio section is gated behind `__FEATURE_PORTFOLIO__`, a build-time
 * literal boolean injected by Vite (see vite.config.ts). When false, the
 * `<Portfolio />` JSX expression is dead code and Rollup tree-shakes the
 * Portfolio import (verified by `pnpm verify:flags`).
 */
export function HomePage(): ReactElement {
  return (
    <>
      <Hero />
      <WhyArpa />
      <Services />
      <ProcessTimeline />
      <RailwaySpecialisation />
      {__FEATURE_PORTFOLIO__ && <Portfolio />}
      <Certification />
      <About />
      <Contact />
    </>
  );
}

export default HomePage;
